import Dashboard from "~/models/dashboards/dashboard";
import DashboardBuilderModel from "~/models/tracked/dashboardBuilderModel";
import {DashboardElementType} from "~/enums/dashboards/dashboardElementType";
import Guid from "~/helpers/guid";
import IRepo from "~/interfaces/repo";
import Repo from "~/state/modules/repo";
import Provider from "~/providers/new/provider";
import DashboardElementDefinition from "~/models/dashboards/elements/dashboardElementDefinition";
import {ISelectedProperty} from "~/state/modules/singleSelectedProperty";
import Vue from "vue";
import {IDashboardElement, IDashboardElementContainer} from "~/interfaces/dashboardInterfaces";
import {Hash} from "~/interfaces/hashInterfaces";
import {RelationType} from "~/models/relationType";
import {ObjectHelper} from "~/helpers/objectHelper";
import ElementHandler from "~/services/elementHandler";
import Validatable from "~/mixins/validatable";
import DashboardElementValidation from "~/models/navigableValidations/dashboardElementValidation";

export default class DashboardElement extends Validatable(DashboardBuilderModel) {
  rootModel: Dashboard;
  sort_order: number;
  content_type: DashboardElementType;
  label_title: string;
  dashboard_elements: Hash<IDashboardElement> = {};

  static repo: IRepo<DashboardElement> = new Repo<DashboardElement>('dashboardElements', DashboardElement, {}, new Provider(DashboardElement, 'dashboard_element', 'dashboard_elements'));
  repo: IRepo<this, Provider<this>>;

  constructor() {
    super();
    this.defineProperty('client_id', Guid.create());
  }

  initialize(root, parent = root, type, json= {}) {
    this.rootModel = root;
    this.parent = parent;
    this.defineProperty('content_type', type);
    this.defineProperty('sort_order', 0);
    this.defineProperty('label_title', '');
    this.loadFromJson(json);
    return this;
  }

  get EMBEDDED_MODELS(): { [key: string]: { type: any, relationType: RelationType } } {
    return {
      "dashboard_elements": {type: DashboardElement, relationType: RelationType.dictionary}
    };
  }

  createEmbeddedObject = {
    dashboard_elements: (parent, json) => {
      const de = this.rootModel.dashboardContentElementFactory(json['content_type']);
      de.addToRepo();
      return de;
    }
  };

  get dashboardElementsArray(): Array<IDashboardElement> {
    return ObjectHelper.toArray(this.dashboard_elements);
  }

  _elementHandler = new ElementHandler(this, DashboardElement, 'dashboard_elements');
  get elementHandler(): ElementHandler {
    return this._elementHandler
  }

  initializeEmbedded(parent: IDashboardElementContainer & IDashboardElement, item: IDashboardElement, position: number, json: object = {}, selectItem: boolean = true) {
    if (parent.content_type !== DashboardElementType.Grid) {
      parent.elementHandler.updateElementPositions(parent, item, position);
    }
    parent.trackCreationDeletion(item.client_id, null, item.asJson(), item);
    item.addToRepo();
    if (selectItem) {
      item.select();
    }

    Vue.set(parent[item.rootName], item.client_id, item);
    return item;
  }

  is(type: DashboardElementType) {
    return this.content_type === type;
  }

  static get rootName(): string {
    return 'dashboard_elements';
  }

  get rootName(): string {
    return DashboardElement.rootName;
  }

  get displayName(): string {
    return this.label_title || DashboardElementDefinition.getDisplayName(this.content_type);
  }

  get controlName(): string {
    return DashboardElementDefinition.getDisplayName(this.content_type);
  }

  get controlIcon(): string {
    return DashboardElementDefinition.getIcon(this.content_type);
  }

  addToRepo(): void {
    DashboardElement.repo.add(this);
  }

  get isLast(): boolean {
    return this.sort_order === this.parent.nextSortOrderFor(this.rootName) - 1;
  }

  get isFirst(): boolean {
    return this.sort_order <= 0;
  }

  afterDestroy() {
    super.afterDestroy();
    this.parent.elementHandler.recalculateElementPositions();
  }

  moveUp(): void {
    if (!this.isFirst) {
      this.sort_order--;
      this.parent.elementHandler.updateElementPositions(this.parent, this, this.sort_order);
    }
  }

  moveDown(): void {
    if (!this.isLast) {
      this.sort_order++;
      this.parent.elementHandler.updateElementPositions(this.parent, this, this.sort_order);
    }
  }

  // LANE: selection related methods breaking ListView builder due to circular ref somewhere. To investigate.
  get selector(): ISelectedProperty {
    return null;
    // return Selected.element;
  }

  select(): void {
    // this.selector.set(this);
  }

  deselect(): void {
    // this.selector.deselectIf(this);
  }

  get isSelected(): boolean {
    return false;
    // return this.selector.is(this);
  }


  //***** validation ***** //
  _validation: DashboardElementValidation<DashboardElement> = new DashboardElementValidation(this);

  getDisplayName(propName: string, value?): string {
    switch (propName) {
      default:
        return propName;
    }
  }
  //***** validation end ***** //
}